
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/post/[slug]",
      function () {
        return require("private-next-pages/blog/post/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/post/[slug]"])
      });
    }
  